module.exports = __webpack_public_path__ + "static/media/10D.7e448065.svg";